import { gql } from "@apollo/client";

export const AllSchemeUrlsQuery = gql`
    query AllSchemeUrls($schemeUrlVersion: String!) {
        allSchemeUrls(schemeUrlVersion: $schemeUrlVersion) {
            url
        }
    }
`;
